"use client";

import { usePathname } from "next/navigation";
import { isAuthPathname } from "@/lib/auth-page";

/** Client-side counterpart of `isAuthPathname` for the current route. */
export function useIsAuthPage(): boolean {
  return isAuthPathname(usePathname());
}
